import {Observable} from 'rxjs';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {AccountStateLogEntry} from '../entity';

@Injectable()
export class AccountStateLogService {

    private BASE_URL = '/api/backoffice';

    constructor(private _http: Http) {
    }

    getAccountStateLog(accountId: number): Observable<Array<AccountStateLogEntry>> {
        return this._http.get(`${this.BASE_URL}/customer-accounts/${accountId}/state-log`)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/account-state-log.service.ts